import React from 'react'

import Badge, { BadgeVariant } from 'components/Badge'
import styled from 'styled-components'

import { MouseoverTooltip } from '../../../../components/Tooltip'

const BadgeWrapper = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  height: 22px;
`

const BadgeText = styled.div`
  font-weight: 400;
  font-size: 12px;
`

const ActiveDot = styled.span`
  background-color: ${({ theme }) => theme.success};
  border-radius: 50%;
  height: 8px;
  width: 8px;
  margin-right: 4px;
`

export default function TagRange({ removed, inRange }: { removed: boolean | undefined; inRange: boolean | undefined }) {
  return (
    <BadgeWrapper>
      {removed ? (
        <MouseoverTooltip text={`Your position has 0 liquidity, and is not earning fees.`}>
          <Badge
            style={{ borderRadius: '8px', height: '22px', borderColor: '#FD4040', color: '#FD4040' }}
            variant={BadgeVariant.WARNING_OUTLINE}
          >
            <BadgeText>Closed</BadgeText>
          </Badge>
        </MouseoverTooltip>
      ) : inRange ? (
        <MouseoverTooltip
          text={`The price of this pool is within your selected range. Your position is currently earning fees.`}
        >
          <Badge style={{ borderRadius: '8px', height: '22px' }} variant={BadgeVariant.DEFAULT}>
            <ActiveDot /> &nbsp;
            <BadgeText>In range</BadgeText>
          </Badge>
        </MouseoverTooltip>
      ) : (
        <MouseoverTooltip
          text={`The price of this pool is outside of your selected range. Your position is not currently earning fees.`}
        >
          <Badge style={{ borderRadius: '8px', height: '22px' }} variant={BadgeVariant.WARNING}>
            &nbsp;
            <BadgeText>Out of range</BadgeText>
          </Badge>
        </MouseoverTooltip>
      )}
    </BadgeWrapper>
  )
}
